const hasClass = (el: any, cssClass: any) => {
  if (el.classList) {
    return el.classList.contains(cssClass);
  }
  return !!el.className.match(new RegExp(`(\\s|^)${cssClass}(\\s|$)`));
};

export const removeClass = (elm: any, cssClass: any) => {
  const el = elm;
  if (el.classList) {
    el.classList.remove(cssClass);
  } else if (hasClass(el, cssClass)) {

    const safeClass = escapeRegex(cssClass);
    const reg = new RegExp(`(\\s|^)${safeClass}(\\s|$)`);

    el.className = el.className.replace(reg, ' ');
  }
};

export const getElementBySelector = (selector: any) => {
  return window.document.querySelector(selector);
};

function escapeRegex(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
